import _ from 'lodash'
import router from '@/router/routes'
import { AI_MATCH_SCORE_COLOR_MAP } from '@/constant/candidate'

function base64SrcToBlob (base64Src) {
  const arr = base64Src.split(',')
  const data = arr[1].substring(0, arr[1].length - 2)
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(data)
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {
    type: mime
  })
}

function imageToBase64 (imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    let timeoutEvent = null
    let hasTimeout = false
    const timeout = 10000 // 10s
    image.onload = () => {
      if (timeoutEvent) {
        clearTimeout(timeoutEvent)
      }
      if (hasTimeout) {
        return
      }
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0)
      resolve(canvas.toDataURL())
    }
    timeoutEvent = setTimeout(() => {
      hasTimeout = true
      resolve(null)
    }, timeout)
    image.src = imageUrl
  })
}

function computedColorLuminance (color) {
  color = color.replace('#', '')
  const r = parseInt(color.substr(0, 2), 16)
  const g = parseInt(color.substr(2, 2), 16)
  const b = parseInt(color.substr(4, 2), 16)
  return 0.299 * r + 0.587 * g + 0.114 * b
}

function getTextColorByBgColor (bgColor) {
  const yiq = computedColorLuminance(bgColor)
  return (yiq >= 160) ? '#000000' : '#FFFFFF'
}

function getFixedHexColor (hexColor, fixValue) {
  const color = hexColor.slice(1)
  let fixedColor = ''
  _.range(0, 6, 2).forEach((index) => {
    const colorValue = parseInt(color.substr(index, 2), 16)
    fixedColor += _.clamp(colorValue + fixValue, 0, 255).toString(16).padStart(2, '0')
  })
  return `#${fixedColor}`
}

function getValueByKeyPath (obj, keyPath) {
  if (!keyPath) {
    return obj
  }
  if (keyPath.includes('.')) {
    const keyArr = keyPath.split('.')
    let tempVal = obj
    let result
    _.forEach(keyArr, item => {
      if (Object.getOwnPropertyNames(tempVal).includes(item)) {
        tempVal = tempVal[item]
        result = tempVal
      } else {
        result = undefined
        return false
      }
    })
    return result
  } else {
    return obj[keyPath]
  }
}

//  A formatted version of a popular md5 implementation.
//  Original copyright (c) Paul Johnston & Greg Holt.
//  The function itself is now 42 lines long.

function md5 (inputString) {
  const hc = '0123456789abcdef'
  function rh (n) { let j; let s = ''; for (j = 0; j <= 3; j++) s += hc.charAt((n >> (j * 8 + 4)) & 0x0F) + hc.charAt((n >> (j * 8)) & 0x0F); return s }
  function ad (x, y) { const l = (x & 0xFFFF) + (y & 0xFFFF); const m = (x >> 16) + (y >> 16) + (l >> 16); return (m << 16) | (l & 0xFFFF) }
  function rl (n, c) { return (n << c) | (n >>> (32 - c)) }
  function cm (q, a, b, x, s, t) { return ad(rl(ad(ad(a, q), ad(x, t)), s), b) }
  function ff (a, b, c, d, x, s, t) { return cm((b & c) | ((~b) & d), a, b, x, s, t) }
  function gg (a, b, c, d, x, s, t) { return cm((b & d) | (c & (~d)), a, b, x, s, t) }
  function hh (a, b, c, d, x, s, t) { return cm(b ^ c ^ d, a, b, x, s, t) }
  function ii (a, b, c, d, x, s, t) { return cm(c ^ (b | (~d)), a, b, x, s, t) }
  function sb (x) {
    let i; const nblk = ((x.length + 8) >> 6) + 1; const blks = new Array(nblk * 16); for (i = 0; i < nblk * 16; i++) blks[i] = 0
    for (i = 0; i < x.length; i++) blks[i >> 2] |= x.charCodeAt(i) << ((i % 4) * 8)
    blks[i >> 2] |= 0x80 << ((i % 4) * 8); blks[nblk * 16 - 2] = x.length * 8; return blks
  }
  let i; const x = sb(inputString); let a = 1732584193; let b = -271733879; let c = -1732584194; let d = 271733878; let olda; let oldb; let oldc; let oldd
  for (i = 0; i < x.length; i += 16) {
    olda = a; oldb = b; oldc = c; oldd = d
    a = ff(a, b, c, d, x[i + 0], 7, -680876936); d = ff(d, a, b, c, x[i + 1], 12, -389564586); c = ff(c, d, a, b, x[i + 2], 17, 606105819)
    b = ff(b, c, d, a, x[i + 3], 22, -1044525330); a = ff(a, b, c, d, x[i + 4], 7, -176418897); d = ff(d, a, b, c, x[i + 5], 12, 1200080426)
    c = ff(c, d, a, b, x[i + 6], 17, -1473231341); b = ff(b, c, d, a, x[i + 7], 22, -45705983); a = ff(a, b, c, d, x[i + 8], 7, 1770035416)
    d = ff(d, a, b, c, x[i + 9], 12, -1958414417); c = ff(c, d, a, b, x[i + 10], 17, -42063); b = ff(b, c, d, a, x[i + 11], 22, -1990404162)
    a = ff(a, b, c, d, x[i + 12], 7, 1804603682); d = ff(d, a, b, c, x[i + 13], 12, -40341101); c = ff(c, d, a, b, x[i + 14], 17, -1502002290)
    b = ff(b, c, d, a, x[i + 15], 22, 1236535329); a = gg(a, b, c, d, x[i + 1], 5, -165796510); d = gg(d, a, b, c, x[i + 6], 9, -1069501632)
    c = gg(c, d, a, b, x[i + 11], 14, 643717713); b = gg(b, c, d, a, x[i + 0], 20, -373897302); a = gg(a, b, c, d, x[i + 5], 5, -701558691)
    d = gg(d, a, b, c, x[i + 10], 9, 38016083); c = gg(c, d, a, b, x[i + 15], 14, -660478335); b = gg(b, c, d, a, x[i + 4], 20, -405537848)
    a = gg(a, b, c, d, x[i + 9], 5, 568446438); d = gg(d, a, b, c, x[i + 14], 9, -1019803690); c = gg(c, d, a, b, x[i + 3], 14, -187363961)
    b = gg(b, c, d, a, x[i + 8], 20, 1163531501); a = gg(a, b, c, d, x[i + 13], 5, -1444681467); d = gg(d, a, b, c, x[i + 2], 9, -51403784)
    c = gg(c, d, a, b, x[i + 7], 14, 1735328473); b = gg(b, c, d, a, x[i + 12], 20, -1926607734); a = hh(a, b, c, d, x[i + 5], 4, -378558)
    d = hh(d, a, b, c, x[i + 8], 11, -2022574463); c = hh(c, d, a, b, x[i + 11], 16, 1839030562); b = hh(b, c, d, a, x[i + 14], 23, -35309556)
    a = hh(a, b, c, d, x[i + 1], 4, -1530992060); d = hh(d, a, b, c, x[i + 4], 11, 1272893353); c = hh(c, d, a, b, x[i + 7], 16, -155497632)
    b = hh(b, c, d, a, x[i + 10], 23, -1094730640); a = hh(a, b, c, d, x[i + 13], 4, 681279174); d = hh(d, a, b, c, x[i + 0], 11, -358537222)
    c = hh(c, d, a, b, x[i + 3], 16, -722521979); b = hh(b, c, d, a, x[i + 6], 23, 76029189); a = hh(a, b, c, d, x[i + 9], 4, -640364487)
    d = hh(d, a, b, c, x[i + 12], 11, -421815835); c = hh(c, d, a, b, x[i + 15], 16, 530742520); b = hh(b, c, d, a, x[i + 2], 23, -995338651)
    a = ii(a, b, c, d, x[i + 0], 6, -198630844); d = ii(d, a, b, c, x[i + 7], 10, 1126891415); c = ii(c, d, a, b, x[i + 14], 15, -1416354905)
    b = ii(b, c, d, a, x[i + 5], 21, -57434055); a = ii(a, b, c, d, x[i + 12], 6, 1700485571); d = ii(d, a, b, c, x[i + 3], 10, -1894986606)
    c = ii(c, d, a, b, x[i + 10], 15, -1051523); b = ii(b, c, d, a, x[i + 1], 21, -2054922799); a = ii(a, b, c, d, x[i + 8], 6, 1873313359)
    d = ii(d, a, b, c, x[i + 15], 10, -30611744); c = ii(c, d, a, b, x[i + 6], 15, -1560198380); b = ii(b, c, d, a, x[i + 13], 21, 1309151649)
    a = ii(a, b, c, d, x[i + 4], 6, -145523070); d = ii(d, a, b, c, x[i + 11], 10, -1120210379); c = ii(c, d, a, b, x[i + 2], 15, 718787259)
    b = ii(b, c, d, a, x[i + 9], 21, -343485551); a = ad(a, olda); b = ad(b, oldb); c = ad(c, oldc); d = ad(d, oldd)
  }
  return rh(a) + rh(b) + rh(c) + rh(d)
}

const userAgent = navigator.userAgent
const isWeChat = /MicroMessenger/i.test(userAgent)
const isWeChatWork = isWeChat && /wxWork/i.test(userAgent)
// const isStarbucksApp = /Joywok/.test(userAgent)
const isStarbucksApp = false
const isWindowsPhone = /(?:Windows Phone)/.test(userAgent)
const isSymbian = /(?:SymbianOS)/.test(userAgent) || isWindowsPhone
const isAndroid = /(?:Android)/.test(userAgent)
const isFireFox = /(?:Firefox)/.test(userAgent)
const isTablet = /(?:iPad|PlayBook)/.test(userAgent) || (isAndroid && !/(?:Mobile)/.test(userAgent)) || (isFireFox && /(?:Tablet)/.test(userAgent))
const isiPhone = /(?:iPhone)/.test(userAgent) && !isTablet
const isiOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent)
const isHarmonyOSMobile = /(?:Phone)/.test(userAgent) && /(?:OpenHarmony)/.test(userAgent)
const isMobile = isAndroid || isiPhone || isSymbian || isHarmonyOSMobile
const isPc = !isMobile
const isJW = isStarbucksApp

const deviceType = {
  isWeChat: isWeChat,
  isWeChatWork: isWeChatWork,
  isStarbucksApp: isStarbucksApp,
  isJW: isJW,
  isWindowsPhone: isWindowsPhone,
  isSymbian: isSymbian,
  isAndroid: isAndroid,
  isFireFox: isFireFox,
  isTablet: isTablet,
  isiPhone: isiPhone,
  isiOS: isiOS,
  isMobile: isMobile,
  isPc: isPc
}

function addQueryInPath (path, query, cover) {
  if (!path) {
    return path
  }
  let base
  if (!path.startsWith('http')) {
    base = window.location.origin
  }
  const url = new URL(path, base)
  const params = url.searchParams
  _.forEach(query, (val, key) => {
    if (val === null || val === undefined) {
      return
    }
    if (cover || !params.has(key)) {
      params.set(key, val)
    }
  })
  let addedPath = url.toString()
  if (base) {
    addedPath = addedPath.slice(base.length)
  }
  return addedPath
}

function addRelatedProperty (obj, propertyName, relatedPropertyPath, relatedObj = null) {
  if (!relatedObj) {
    relatedObj = obj
  }
  Object.defineProperty(obj, propertyName, {
    configurable: true,
    enumerable: true,
    get () {
      return _.get(relatedObj, relatedPropertyPath)
    }
  })
}

class AsyncTask {
  constructor (onCreateTask, onGetTaskStatus, onFinished, getterIdle, onError) {
    this.onCreateTask = onCreateTask
    this.onGetTaskStatus = onGetTaskStatus
    this.onFinished = onFinished
    this.onError = onError
    this.getterIdle = getterIdle || 1000
    this.promise = new Promise((resolve) => {
      this.resolve = resolve
    })
    if (this.onFinished) {
      this.promise.then(({ taskId, resp }) => this.onFinished(taskId, resp))
    }
    this.createTask()
  }

  _onFinished (resp) {
    this.resolve({ taskId: this.taskId, resp })
  }

  async createTask () {
    const resp = await this.onCreateTask()
    this.taskId = resp.task_id
    this.isFinished = resp.is_finished
    setTimeout(() => this._wait().catch(error => this._onError(error)), this.getterIdle)
  }

  async _wait () {
    const resp = await this.onGetTaskStatus(this.taskId, this)
    this.isFinished = resp.is_finished
    if (this.isFinished) {
      this._onFinished(resp)
    } else {
      setTimeout(() => this._wait().catch(error => this._onError(error)), this.getterIdle)
    }
  }

  async waitTaskFinish () {
    await this.promise
  }
}

function getScoreColor (score) {
  if (!score && score !== 0) {
    return
  }
  const intVal = parseInt(score)
  let color = 'rgb(226, 118, 118)' // red
  if (intVal > 40 && intVal < 70) {
    color = 'rgb(244, 169, 88)' // orange
  } else if (intVal >= 70) {
    color = 'rgb(81, 191, 130)' // green
  }
  return color
}

function getJobFitScoreColor (val, defaultColor = 'rgb(244, 169, 88)') {
  return _.get(AI_MATCH_SCORE_COLOR_MAP, val, defaultColor)
}

function formatJobFitScore (val) {
  if (val === 'A') {
    return 100
  } else if (val === 'B') {
    return 66
  } else if (val === 'C') {
    return 33
  } else {
    return null
  }
}

function appendSourceCode (url) {
  const route = router.currentRoute
  const source = route.query.aj_source
  const code = route.query.aj_code
  if (source || code) {
    url = addQueryInPath(url, {
      aj_source: source,
      aj_code: code
    })
  }
  return url
}

function openNewBrowserWindowByUrl (url, name, customWidth, customHeight) {
  // 设置宽高的默认值
  if (!customWidth) {
    customWidth = window.screen.width / 1.5
  }
  if (!customHeight) {
    customHeight = window.screen.height / 1.5
  }
  // 获得窗口的垂直位置
  // window.screen.height获得屏幕的高
  const top = (window.screen.height - 30 - customHeight) / 2
  // 获得窗口的水平位置
  // window.screenX: 浏览器左边界到操作系统桌面左边界的水平距离
  // window.screenLeft：浏览器左边框到左边屏幕边缘的 CSS 像素数
  // screen.width: 屏幕的宽度
  const left = (window.screenX || window.screenLeft || 0) + (screen.width - customWidth) / 2
  const features = `height=${customHeight}, innerHeight=${customHeight}, width=${customWidth}, innerWidth=${customWidth}, top=${top}, left=${left}, toolbar=no, menubar=no, scrollbars=auto, resizable=no`
  const winUrl = window.open(url, name, features)
  return winUrl
}

function parseStylePxToInt (pxStr) {
  if (!pxStr) {
    return 0
  }
  pxStr = pxStr.replace('px', '')
  return parseInt(pxStr)
}

export {
  getValueByKeyPath, deviceType, base64SrcToBlob, getTextColorByBgColor, imageToBase64, md5, getFixedHexColor, addQueryInPath, addRelatedProperty, AsyncTask, getScoreColor, appendSourceCode,
  openNewBrowserWindowByUrl, parseStylePxToInt, getJobFitScoreColor, formatJobFitScore, computedColorLuminance
}
